var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
        outline: _vm.outline,
        fullWidth: _vm.fullWidth,
        red: _vm.red,
        redOutline: _vm.redOutline,
        danger: _vm.danger,
        disabled: _vm.disabled,
        transparent: _vm.transparent,
        loading: _vm.loading,
        icon: _vm.icon,
        inverse: _vm.inverse,
        'icon--right': _vm.icon && _vm.rightIcon,
        small: _vm.small
    },attrs:{"disabled":_vm.loading || _vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('div',{staticClass:"loading-icon"},[_c('LoadingIcon')],1):_vm._t("default"),_vm._v(" "),(_vm.icon.length > 0)?_c('div',{staticClass:"icon",class:{ 'icon--right': _vm.rightIcon }},[_c('svg-icon',{attrs:{"iconName":_vm.icon}})],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }